import { Component, OnInit } from '@angular/core';
import { PwaInstallService } from '../service/security/pwa-install.service';

type JourneyType = 'particulier' | 'business';

interface JourneyStep {
  title: string;
  text: string;
  icon: string;
}

interface JourneyContent {
  eyebrow: string;
  title: string;
  badge: string;
  steps: JourneyStep[];
}

@Component({
    selector: 'app-homeindex',
    templateUrl: './homeindex.component.html',
    styleUrls: ['./homeindex.component.css'],
    standalone: false
})
export class HomeindexComponent implements OnInit {
  activeJourney: JourneyType = 'particulier';
  installHelpVisible = false;

  readonly journeys: Record<JourneyType, JourneyContent> = {
    particulier: {
      eyebrow: 'Parcours particulier',
      title: 'Activez votre wallet et gérez vos paiements du quotidien en 3 étapes.',
      badge: 'Particulier',
      steps: [
        {
          title: 'Créer',
          text: 'Inscrivez-vous rapidement, validez votre profil et activez votre portefeuille.',
          icon: 'bi bi-person-plus'
        },
        {
          title: 'Opérer',
          text: 'Transférez, retirez et déposez avec confirmation de chaque opération.',
          icon: 'bi bi-arrow-left-right'
        },
        {
          title: 'Suivre',
          text: 'Consultez votre solde et votre historique détaillé en temps réel.',
          icon: 'bi bi-graph-up'
        }
      ]
    },
    business: {
      eyebrow: 'Parcours business',
      title: 'Lancez vos encaissements et pilotez vos équipes avec un flux simple.',
      badge: 'Business',
      steps: [
        {
          title: 'Ouvrir',
          text: 'Créez votre compte marchand et centralisez vos flux de paiement.',
          icon: 'bi bi-briefcase'
        },
        {
          title: 'Encaisser',
          text: 'Réalisez dépôts, retraits et prélèvements depuis une interface unique.',
          icon: 'bi bi-cash-stack'
        },
        {
          title: 'Contrôler',
          text: 'Suivez vos mouvements, vos marges et gérez les accès de vos caissiers.',
          icon: 'bi bi-shield-check'
        }
      ]
    }
  };

  constructor(private pwaInstallService: PwaInstallService) { }

  ngOnInit(): void {
  }

  setJourney(journey: JourneyType): void {
    this.activeJourney = journey;
  }

  shouldInstallPwa(): boolean {
    return this.pwaInstallService.shouldShowInstall();
  }

  isPwaInstalled(): boolean {
    return this.pwaInstallService.isRunningStandalone();
  }

  installPwa(): void {
    if (this.shouldInstallPwa()) {
      this.installHelpVisible = false;
      void this.pwaInstallService.install();
      return;
    }

    this.installHelpVisible = !this.isPwaInstalled();
  }

  getInstallButtonLabel(): string {
    if (this.isPwaInstalled()) {
      return 'App installée';
    }

    return 'Installer l\'app';
  }

  getInstallButtonIcon(): string {
    if (this.isPwaInstalled()) {
      return 'bi bi-check2-circle';
    }

    if (this.shouldInstallPwa()) {
      return 'bi bi-download';
    }

    return 'bi bi-phone';
  }

  get activeJourneyContent(): JourneyContent {
    return this.journeys[this.activeJourney];
  }

}
